export class VPaginationRequestData<T> {
  public filterData: T;

  constructor(data: T) {
    this.filterData = data;
  }
}
